import { NumberInput, SelectInputV2 } from '@frontend/components/basic-forms';
import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

type IntervalType = 'day' | 'week' | 'month';

const DAYS_IN: Record<IntervalType, number> = {
    day: 1,
    week: 7,
    month: 30 // 30 days
};

interface IntervalSelectProps {
    onChange?: (seconds: number) => void;
}

export const IntervalSelect = (props: IntervalSelectProps) => {
    const [amount, setAmount] = useState<number>(1);
    const [type, setType] = useState<IntervalType>('day');
    const seconds = useMemo(() => amount * DAYS_IN[type], [amount, type]);

    const handleAmountChange = (e: number) => {
        const value = Math.max(1, Math.min(99, e));
        setAmount(value);
    };

    const handleTypeChange = (e: string | undefined) => {
        const value = e as IntervalType;
        setType(value);
    };

    useEffect(() => {
        if (props.onChange) props.onChange(seconds);
    }, [seconds]);

    return (
        <div className='flex w-full flex-col gap-3'>
            <NumberInput
                label={
                    <FormattedMessage
                        id='amount'
                        defaultMessage='Amount'
                    />
                }
                min={1}
                max={99}
                value={amount}
                onChange={handleAmountChange}
            />
            <SelectInputV2
                label={
                    <FormattedMessage
                        id='type'
                        defaultMessage='Type'
                    />
                }
                value={type}
                onSelect={(option) => handleTypeChange(option?.value)}
                options={[
                    { label: 'Day(s)', value: 'day' },
                    { label: 'Week(s)', value: 'week' },
                    { label: 'Month(s)', value: 'month' }
                ]}
            />
        </div>
    );
};
